import {
  Auth,
  User,
  onIdTokenChanged,
  signInWithCustomToken,
} from "@angular/fire/auth";
import { Store } from "@ngrx/store";
import { Router } from "@angular/router";
import { Injectable, inject } from "@angular/core";
import { from, map, Observable, Subscription } from "rxjs";
import { UserModel } from "src/app/store/models/user.model";
import {
  StorageService,
  imageCacheTenantKey,
  KEPT_ON_LOGOUT_IMAGE_CACHES,
} from "../storage-service/storage.service";
import { FirebaseService } from "../firebase-service/firebase.service";
import { ADD_USER, UPDATE_USER } from "src/app/store/actions/user.action";

@Injectable({ providedIn: "root" })
export class AuthService {
  private readonly auth = inject(Auth);
  private readonly store = inject(Store);
  private readonly router = inject(Router);
  private readonly storage = inject(StorageService);
  private readonly firebaseSevice = inject(FirebaseService);

  private authSubscription: Subscription;

  constructor() {
    this.RefreshToken();
  }

  // !! DO NOT REMOVE
  RefreshToken() {
    onIdTokenChanged(this.auth, async (fireUser: User | null) => {
      let user: UserModel = await this.storage.get("user");
      if (user && user.email && user.token) {
        if (fireUser) {
          const idToken = await fireUser.getIdToken();
          user = { ...user, token: idToken };
          await this.storage.set("user", user);
          this.store.dispatch(UPDATE_USER(user));
          this.firebaseSevice.updateUser(user.email!, idToken);
        }
      }
    });
  }
  // !! DO NOT REMOVE

  async getUserOnce(): Promise<User | null> {
    let promise: Promise<User | null> | null = null;
    if (this.auth.currentUser) return this.auth.currentUser;
    if (!promise) {
      promise = new Promise((resolve) => {
        const unsubscribe = onIdTokenChanged(this.auth, (user) => {
          unsubscribe();
          resolve(user);
        });
      });
    }
    return promise;
  }

  async getToken(): Promise<string | null> {
    const user = this.auth.currentUser;
    return user ? await user.getIdToken() : null;
  }

  async SignIn(token: string) {
    const userCred = await signInWithCustomToken(this.auth, token);
    if (userCred && userCred.user && userCred.user.uid) {
      let user = await this.storage.get("user");
      const idToken = await this.auth.currentUser?.getIdToken();

      user = { ...user, token: idToken };
      this.storage.set("user", { ...user });
      this.store.dispatch(UPDATE_USER({ ...user }));

      return true;
    } else {
      return false;
    }
  }

  async SignOut(loading?: HTMLIonLoadingElement) {
    if (this.authSubscription) {
      this.authSubscription.unsubscribe();
    }

    this.auth
      .signOut()
      .then(() => {
        loading?.dismiss();
        this.auth.signOut();
        this.storage.clearExcept([
          ...KEPT_ON_LOGOUT_IMAGE_CACHES,
          ...KEPT_ON_LOGOUT_IMAGE_CACHES.map(imageCacheTenantKey),
        ]);
        this.router.navigate(["/login"]);
        this.store.dispatch(ADD_USER({}));
      })
      .catch((error) => {
        console.error("Error during sign out:", error);
        loading?.dismiss();
      });
  }

  isAuthenticated(): Observable<boolean> {
    return from(this.storage.get("user")).pipe(
      map((user: UserModel) => {
        return !!(user && user.email && user.token);
      }),
    );
  }
}
